import { __assign, __extends } from "tslib";
import React from 'react';
import DotsIcon from '../svgs/components/dots';
import { GALLERY_v4_CONSTS } from '@wix/photography-client-lib';
var Dots = /** @class */ (function (_super) {
    __extends(Dots, _super);
    function Dots(props) {
        var _this = _super.call(this, props) || this;
        _this.onKeyPress = _this.onKeyPress.bind(_this);
        _this.onDotsClick = _this.onDotsClick.bind(_this);
        _this.getClickAction = _this.getClickAction.bind(_this);
        return _this;
    }
    Dots.prototype.onDotsClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
        this.props.onDotsClick && this.props.onDotsClick();
    };
    Dots.prototype.onKeyPress = function (e) {
        switch (e.keyCode || e.charCode) {
            case 32: // space
            case 13: // enter
                e.preventDefault();
                e.stopPropagation();
                this.onDotsClick(e);
                return false;
            default:
                break;
        }
    };
    Dots.prototype.getClickAction = function () {
        if (this.props.viewMode === GALLERY_v4_CONSTS.viewMode.SITE ||
            this.props.viewMode === GALLERY_v4_CONSTS.viewMode.SEO) {
            var action = this.onDotsClick;
            return this.props.isMobile ? { onTouchEnd: action } : { onClick: action };
        }
        else {
            return { onClick: function (e) { return e.stopPropagation(); } };
        }
    };
    Dots.prototype.render = function () {
        var clickAction = this.getClickAction();
        var DotsIconElement = React.createElement(DotsIcon, __assign({}, clickAction, { size: "20" }));
        if (this.props.dotsWrapper) {
            DotsIconElement = this.props.dotsWrapper(__assign({ dotsElement: DotsIconElement }, this.props));
        }
        return React.createElement("div", { className: 'info-member info-element-social-button info-element-social-dots', "data-hook": "item-dots", "aria-label": "Dots", role: "button", tabIndex: -1 }, DotsIconElement);
    };
    return Dots;
}(React.Component));
export default Dots;
//# sourceMappingURL=Dots.js.map